import { ClientsPreferences } from 'src/app/shared/models/client-storage.model';

export class DynamicDashboardPreferences extends ClientsPreferences<{}>{

}
export enum DashboardType {
    DEVICES_HEALTH_DASHBOARD = "Devices Health Dashboard",
    ORG_REPORTS = "Organization Reports",
    TENANT_REPORTS = "Tenant Reports",
    VENUE_REPORTS = "Venue Reports",
    DEVICE_REPORTS = "Device Reports",
    REPORT_PAGE = "Report Page",
}
